import React from "react";
import "./SideBarBgContainer.css";
import { Box } from "@mui/material";

interface SideBarBgContainerProps {
  children: React.ReactNode;
  className?: string;
}

const SideBarBgContainer: React.FC<SideBarBgContainerProps> = ({
  children,
  className,
}) => {
  return <Box className={`siderbar-bg-container ${className}`}>{children}</Box>;
};

export default SideBarBgContainer;
